import { connect } from 'react-redux';
import TableChart from '../../shared/widgets/TableChart';
import {
  addChartToTableAction,
  updateColumnHiddenValueAction,
  updateCustomizedArrayPropAction
} from '../../pages/TableEditorPage/actions/tableEditor.js';

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => ({
  addChartToTable: (index) => dispatch(addChartToTableAction({ index })),
  updateColumnHiddenValue: (columns, value) =>
    dispatch(updateColumnHiddenValueAction({ columns, value })),
  updateCustomizedArrayProp: (parent, index, val, moveObj) =>
    dispatch(updateCustomizedArrayPropAction({ parent, index, val, moveObj })),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(TableChart);
